import React from 'react';
import AppRoutes from 'src/routes';
import { useAuth } from 'src/AuthContext';
import ErrorBoundary from 'src/components/shared/ErrorBoundary';
import EstadoErroInesperado from 'src/components/casca/EstadoErroInesperado';

/**
 * App — componente raiz.
 * Aguarda `inicializando` antes de renderizar as rotas para evitar
 * que o PrivateRoute redirecione para /login antes de o localStorage
 * ser verificado, o que causava o reset para a tela inicial no refresh.
 *
 * ErrorBoundary envolve AppRoutes para capturar qualquer crash de
 * componente filho (ex: react-quill, libs de terceiros) e exibir
 * UI de fallback em vez de tela em branco.
 */
function App() {
  const { inicializando } = useAuth();

  if (inicializando) {
    return (
      <div style={{
        display: 'flex', height: '100vh',
        justifyContent: 'center', alignItems: 'center',
        backgroundColor: '#0f172a',
      }}>
        <p style={{ color: '#64748b', fontSize: 14, letterSpacing: 1 }}>
          Verificando sessão...
        </p>
      </div>
    );
  }

  return (
    <ErrorBoundary fallback={<EstadoErroInesperado />}>
      <AppRoutes />
    </ErrorBoundary>
  );
}

export default App;